/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Updatesuccess2Inputs */

const en_coinvestments_nrl_updatesuccess2 = /** @type {(inputs: Coinvestments_Nrl_Updatesuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Release Letter updated successfully`)
};

/**
* | output |
* | --- |
* | "Non-Release Letter updated successfully" |
*
* @param {Coinvestments_Nrl_Updatesuccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_updatesuccess2 = /** @type {((inputs?: Coinvestments_Nrl_Updatesuccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Updatesuccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_updatesuccess2(inputs)
});
export { coinvestments_nrl_updatesuccess2 as "coInvestments_nrl_updateSuccess" }